/*
 * STEP 7C - Beatrice Lencioni | Tracciamento clic WhatsApp v2
 * Progetto per Shopify Dawn. NON invia messaggi WhatsApp.
 * GA4: push dataLayer event "bl_wa_click_v2" (da collegare in GTM).
 * Privacy: nessun tracciamento in assenza del relativo consenso Shopify.
 * Referenza "BL-ADS" aggiunta al messaggio SOLO dopo consenso analytics+marketing
 * e quando una provenienza Google Ads e' rilevata nella sessione.
 */
(function () {
  'use strict';
  if (window.__blWhatsappTrackingV2) return;
  window.__blWhatsappTrackingV2 = true;

  var CONFIG = {
    recipientPhone: '393280275723', // VERIFICARE sul sito live prima di installare
    sessionKey: 'bl_paid_google_visit_v2',
    sessionDurationMs: 30 * 60 * 1000,
    defaultWhatsAppText: 'Ciao Beatrice, vorrei informazioni sul primo colloquio conoscitivo.',
    eventName: 'bl_wa_click_v2'
  };

  function permissions() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api) return { analytics: false, marketing: false };
    try {
      return {
        analytics: api.analyticsProcessingAllowed() === true,
        marketing: api.marketingAllowed() === true
      };
    } catch (_err) {
      return { analytics: false, marketing: false };
    }
  }

  function pageGroup(pathname) {
    var path = (pathname || '').toLowerCase();
    if (path.indexOf('/pages/crisi-di-coppia') >= 0) return 'coppia';
    if (path.indexOf('/pages/counselor-torino') >= 0) return 'counselor_torino';
    if (path.indexOf('/pages/colloquio-online-gratuito') >= 0) return 'colloquio';
    if (path === '/') return 'home';
    return 'altre_pagine';
  }

  function isGooglePaidArrival() {
    var q = new URL(window.location.href).searchParams;
    if (q.has('gclid') || q.has('gbraid') || q.has('wbraid')) return true;
    var source = (q.get('utm_source') || '').toLowerCase();
    var medium = (q.get('utm_medium') || '').toLowerCase();
    return source === 'google' && ['cpc', 'ppc', 'paidsearch', 'paid_search'].indexOf(medium) >= 0;
  }

  function clearSavedPaidSession() {
    try { window.sessionStorage.removeItem(CONFIG.sessionKey); } catch (_err) {}
  }

  var arrivalRecordedForThisPage = false;

  function rememberPaidArrival() {
    var consent = permissions();
    if (!consent.analytics || !consent.marketing) {
      clearSavedPaidSession();
      return;
    }
    if (arrivalRecordedForThisPage || !isGooglePaidArrival()) return;
    arrivalRecordedForThisPage = true;
    try {
      window.sessionStorage.setItem(CONFIG.sessionKey, JSON.stringify({
        expires: Date.now() + CONFIG.sessionDurationMs,
        arrival_page_group: pageGroup(window.location.pathname)
      }));
    } catch (_err) {}
  }

  function paidSession() {
    var consent = permissions();
    if (!consent.analytics || !consent.marketing) return null;
    rememberPaidArrival();
    try {
      var raw = window.sessionStorage.getItem(CONFIG.sessionKey);
      var data = raw && JSON.parse(raw);
      if (data && data.expires > Date.now()) return data;
      clearSavedPaidSession();
    } catch (_err) {}
    return null;
  }

  function ownWhatsAppURL(originalHref) {
    var u;
    try { u = new URL(originalHref, window.location.href); } catch (_err) { return null; }
    var host = u.hostname.toLowerCase();
    var phone = '';
    if (host === 'wa.me') phone = u.pathname.replace(/^\/+/, '').split('/')[0];
    else if ((host === 'api.whatsapp.com' || host === 'web.whatsapp.com') && u.pathname.indexOf('/send') === 0) {
      phone = u.searchParams.get('phone') || '';
    } else return null;
    phone = phone.replace(/\D/g, '');
    return phone === CONFIG.recipientPhone ? u : null;
  }

  function cleanMisleadingUTMs(url) {
    // UTM statici inseriti nell'URL di wa.me NON provano la provenienza dall'annuncio.
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (p) {
      url.searchParams.delete(p);
    });
  }

  function addVisibleAdReference(url, paid) {
    if (!paid) return;
    var group = paid.arrival_page_group || 'altre_pagine';
    var ref = group === 'coppia' ? 'BL-ADS-COP' : group === 'counselor_torino' ? 'BL-ADS-CTO' : 'BL-ADS';
    var text = url.searchParams.get('text') || CONFIG.defaultWhatsAppText;
    if (/Rif\.\s*BL-ADS(?:-CTO|-COP)?\b/i.test(text)) return;
    url.searchParams.set('text', text + '\n\nRif. ' + ref);
  }

  function onWhatsAppClick(ev) {
    if (ev.type === 'click' && ev.button !== 0) return;
    if (ev.type === 'auxclick' && ev.button !== 1) return;
    if (ev.defaultPrevented) return;

    var el = ev.target && (ev.target.nodeType === 1 ? ev.target : ev.target.parentElement);
    var anchor = el && el.closest && el.closest('a[href]');
    if (!anchor || anchor.hasAttribute('data-bl-wa-ignore')) return;

    // Ricostruisce il link dal valore originale per evitare riferimenti obsoleti.
    if (!anchor.hasAttribute('data-bl-wa-original')) {
      anchor.setAttribute('data-bl-wa-original', anchor.getAttribute('href'));
    }
    var url = ownWhatsAppURL(anchor.getAttribute('data-bl-wa-original'));
    if (!url) return;
    cleanMisleadingUTMs(url);

    var consent = permissions();
    var paid = consent.analytics && consent.marketing ? paidSession() : null;
    addVisibleAdReference(url, paid);
    anchor.href = url.toString();

    if (!consent.analytics) return;
    // L'evento è distinto dal "click_whatsapp" già usato in Google Ads.
    // Non inviare telefono, testo della chat, GCLID o identificativi univoci a GA4.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: CONFIG.eventName,
      bl_wa_page_group: pageGroup(window.location.pathname),
      bl_wa_placement: anchor.getAttribute('data-bl-wa-placement') || 'non_classificato',
      bl_wa_google_ads: paid ? 'rilevato' : 'non_verificato',
      bl_wa_arrival_group: paid ? paid.arrival_page_group : 'non_verificato'
    });
  }

  document.addEventListener('click', onWhatsAppClick, true);
  document.addEventListener('auxclick', onWhatsAppClick, true);
  document.addEventListener('visitorConsentCollected', function () {
    rememberPaidArrival();
  });
  rememberPaidArrival();
})();
